module.exports = __webpack_public_path__ + "img/pass_right_2.32ff65e4.jpg";